module.exports = __webpack_public_path__ + "img/39_70.b6ff78de.png";